import {
  BillItem,
  BillType,
  ClientInfoType,
  IProductDiscountSetting,
  IProductTaxSetting,
  ProductType,
} from '../../../all-types'
import { calculateFullBillingInfo } from '../../../utils'
import { ProductDiscountCalc } from './product-discount-calc'
import { ProductTaxCalc } from './product-tax-calc'

class BillCalculator {
  bill: BillType
  allproducts: ProductType[]
  clientInfo: ClientInfoType

  constructor(
    bill: BillType,
    allproducts: ProductType[],
    clientInfo: ClientInfoType
  ) {
    this.bill = bill
    this.allproducts = allproducts
    this.clientInfo = clientInfo
  }

  getProcessedBillingInfo = (fullBill: BillType = this.bill) =>
    calculateFullBillingInfo(fullBill)

  applyFullBillDiscount = (discountComp: string[]) => {
    try {
      this.bill.items?.forEach((item) => {
        const product = this.allproducts.find(
          (p) => p.productId === item.productId
        )
        console.log('Applying discount on item', item, product)
        if (product) {
          this.applyDiscountOnItem(item, product.discounts, discountComp)
          this.applyTaxOnItem(item, product.tax)
        }
      })
      const billingInfo = this.getProcessedBillingInfo(this.bill)
      this.bill.billingInfo = billingInfo
    } catch (e) {
      console.error(e)
    }
  }

  applyDiscountOnItem = (
    item: BillItem,
    productDiscountSettings: IProductDiscountSetting,
    fullBillDiscountCompos: string[] = []
  ) => {
    const productDiscountCalc = new ProductDiscountCalc(
      this.clientInfo.discountManager,
      productDiscountSettings
    )
    productDiscountCalc.applyDiscountByProductSettings(
      item.amount,
      fullBillDiscountCompos
    )
    item.billingInfo.discounts = productDiscountCalc.billDiscount
    item.billingInfo.totalDiscountGiven =
      productDiscountCalc.billDiscount.discountAmount
  }

  applyTaxOnItem = (item: BillItem, productTaxSettings: IProductTaxSetting) => {
    const productTaxCalc = new ProductTaxCalc(
      this.clientInfo.taxManager,
      productTaxSettings
    )
    const amountForTax = item.billingInfo.discounts.isDiscountApplied
      ? item.billingInfo.discounts.amountAfterDiscount
      : item.amount
    productTaxCalc.applyProductTax(amountForTax)
    const TOTAL_DISCOUNT = item.billingInfo.discounts.discountAmount
    const TOTAL_TAX = productTaxCalc.billTax.taxAmount
    item.billingInfo.tax = productTaxCalc.billTax
    item.billingInfo.totalTaxCharged = TOTAL_TAX
    item.billingInfo.finalAmount = item.amount - TOTAL_DISCOUNT + TOTAL_TAX
    item.billingInfo.rawAmount = item.amount
  }
}

export { BillCalculator }
